import React, { useState } from "react";
import MainCalculatorsList from "./MainCalculators";
import SharedHelmet from "../Helmet";
import RelatedLinks from "../RelatedLinks";
import { FirstAds, SecondAds , MobileUnderCalAds } from "../../Ads";

const TITLE = "Calculatrice d'Anniversaire de Mariage - Calcul de la durée du mariage";
const DESCRIPTION =
  "Calculez dates, durees et ages en ligne avec precision pour vos besoins personnels et administratifs.";
const KEYWORDS =
  "calculatrice age et date, duree, calendrier, calcul en ligne";
const OG_URL = "https://do-calculate.com/calculator/fr/wedding-anniversary-calculator/";

const ANNIVERSARY_GIFTS = {
  1: "Cadeau de Papier (ou Montres Modernes)",
  2: "Cadeau de Coton (ou Porcelaine)",
  3: "Cadeau de Cuir (ou Verre)",
  4: "Cadeau de Fruits/Fleurs (ou Appareils Électroniques)",
  5: "Cadeau de Bois (ou Argent)",
  10: "Cadeau d'Étain/Aluminium (ou Diamant)",
  15: "Cadeau de Cristal",
  20: "Cadeau de Porcelaine",
  25: "Cadeau d'Argent",
  30: "Cadeau de Perле",
  40: "Cadeau de Rubis",
  50: "Cadeau d'Or",
  60: "Cadeau de Diamant"
};

const GREGORIAN_MONTHS = [
  "Janvier", "Février", "Mars", "Avril",
  "Mai", "Juin", "Juillet", "Août",
  "Septembre", "Octobre", "Novembre", "Décembre"
];

function Calculator() {
  const [weddingDateState, setWeddingDateState] = useState({
    day: "1",
    month: "1",
    year: "2020"
  });
  const [results, setResults] = useState(null);
  const [error, setError] = useState("");

  const calculateAnniversary = () => {
    const wedding = new Date(
      parseInt(weddingDateState.year),
      parseInt(weddingDateState.month) - 1,
      parseInt(weddingDateState.day)
    );
    const today = new Date();

    if (isNaN(wedding.getTime())) {
      setError("Veuillez entrer la date de mariage correctement");
      setResults(null);
      return;
    }

    if (wedding > today) {
      setError("La date de mariage ne peut pas être dans le futur");
      setResults(null);
      return;
    }

    const timeDiff = Math.abs(today - wedding);
    const diffInDays = Math.floor(timeDiff / (1000 * 3600 * 24));
    const diffInMonths = Math.floor(diffInDays / 30.436875);
    const diffInYears = Math.floor(diffInDays / 365.25);

    const nextAnniversary = new Date(wedding);
    nextAnniversary.setFullYear(today.getFullYear());

    if (nextAnniversary < today) {
      nextAnniversary.setFullYear(today.getFullYear() + 1);
    }

    const daysToNextAnniversary = Math.floor((nextAnniversary - today) / (1000 * 3600 * 24));
    const nextYear = diffInYears + 1;
    const traditionalGift = ANNIVERSARY_GIFTS[nextYear] || "Vous pouvez choisir un cadeau spécial";
    const currentGift = ANNIVERSARY_GIFTS[diffInYears] || "Vous pouvez choisir un cadeau spécial";

    setResults({
      years: diffInYears,
      months: diffInMonths,
      days: diffInDays,
      daysToNextAnniversary: daysToNextAnniversary,
      nextAnniversaryDate: nextAnniversary.toLocaleDateString("fr-FR", { weekday: "long", year: "numeric", month: "long", day: "numeric" }),
      currentGift: currentGift,
      traditionalGift: traditionalGift,
    });
    setError("");
  };

  return (
    <div style={{ direction: "ltr" }}>
      <SharedHelmet
        TITLE={TITLE}
        DESCRIPTION={DESCRIPTION}
        KEYWORDS={KEYWORDS}
        OG_URL={OG_URL}
      />

      <div className="row">
        <div className="col-12 col-md-8">
          <FirstAds />
        </div>
      </div>

      <div className="row">
        <div className="col-12 col-md-8">
          <br />
          <div className="bg-success text-white text-center p-3">
            <h1 style={{ fontSize: "20px", margin: 0 }}>{TITLE}</h1>
          </div>

          <div className="border border-light p-3">
            <p>
              Calculez la durée exacte de votre mariage en années, mois et jours. Cette calculatrice affiche également la date de votre prochain anniversaire de mariage et suggère des cadeaux d'anniversaire traditionnels.
            </p>
            <hr />
            <MobileUnderCalAds />

            <div className="calculatorStyle p-3 bg-light rounded">
              <div className="p-2 mb-3 bg-success text-white">
                <strong>Entrez votre date de mariage</strong>
              </div>

              <div className="mb-3">
                <label><strong>Jour:</strong></label>
                <select
                  className="form-control"
                  value={weddingDateState.day}
                  onChange={(e) => setWeddingDateState({ ...weddingDateState, day: e.target.value })}
                >
                  {Array.from({ length: 31 }, (_, i) => i + 1).map(d => (
                    <option key={d} value={d}>{d}</option>
                  ))}
                </select>
              </div>

              <div className="mb-3">
                <label><strong>Mois:</strong></label>
                <select
                  className="form-control"
                  value={weddingDateState.month}
                  onChange={(e) => setWeddingDateState({ ...weddingDateState, month: e.target.value })}
                >
                  {GREGORIAN_MONTHS.map((m, i) => (
                    <option key={i + 1} value={i + 1}>{i + 1} - {m}</option>
                  ))}
                </select>
              </div>

              <div className="mb-3">
                <label><strong>Année:</strong></label>
                <select
                  className="form-control"
                  value={weddingDateState.year}
                  onChange={(e) => setWeddingDateState({ ...weddingDateState, year: e.target.value })}
                >
                  {Array.from({ length: 100 }, (_, i) => new Date().getFullYear() - i).map(y => (
                    <option key={y} value={y}>{y}</option>
                  ))}
                </select>
              </div>

              <div className="text-center mb-4">
                <button className="btn btn-success btn-lg px-5" onClick={calculateAnniversary}>
                  Calculer l'Anniversaire
                </button>
              </div>

              {error && <div className="alert alert-danger">{error}</div>}

              {results && (
                <div className="alert alert-success mt-4">
                  <h3>Résultats de Votre Mariage:</h3>
                  <div className="mb-3">
                    <strong style={{ fontSize: "24px", color: "#28a745" }}>
                      {results.years} ans, {results.months} mois et {results.days} jours
                    </strong>
                  </div>
                  <div className="mt-3">
                    <p><strong>Détails:</strong></p>
                    <ul>
                      <li>Jours totaux: {results.days}</li>
                      <li>Prochain anniversaire: {results.nextAnniversaryDate}</li>
                      <li>Jours jusqu'au prochain anniversaire: {results.daysToNextAnniversary}</li>
                      <li><strong>Cadeau traditionnel de cette année:</strong> {results.currentGift}</li>
                      <li><strong>Cadeau pour l'anniversaire prochain:</strong> {results.traditionalGift}</li>
                    </ul>
                  </div>
                </div>
              )}
            </div>
          </div>

          <br />
          <SecondAds />
          <br />
          <MainCalculatorsList />
          <br />
          <RelatedLinks />
          <br />
          <div className="info-sections-container">
            <div className="info-section">
              <div className="info-section-header"><h3 style={{ fontSize: "16px" }}>Calculatrice d’anniversaire</h3></div>
              <div className="info-section-body">
                <p>Cette calculatrice d’anniversaire vous permet de savoir combien de jours restent avant votre prochain anniversaire, ou avant celui d’un proche. Elle calcule aussi le jour de la semaine de n’importe quelle date de naissance et indique depuis combien d’années vous célébrez cet événement.</p>
              </div>
            </div>
            <div className="info-section">
              <div className="info-section-header"><h3 style={{ fontSize: "16px" }}>Noms des anniversaires de mariage en France</h3></div>
              <div className="info-section-body">
                <p>En France, chaque année de mariage a un nom traditionnel : les noces de coton (1 an), de bois (5 ans), d'étain (10 ans), d'argent (25 ans), d'or (50 ans) et de diamant (60 ans). Ces noms sont utilisés pour choisir des cadeaux symboliques à offrir aux mariés à chaque étape importante de leur vie commune.</p>
              </div>
            </div>
            <div className="info-section">
              <div className="info-section-header">Comment fonctionne la calculatrice d'anniversaire de mariage ?</div>
              <div className="info-section-body">
                <p>Entrez la date de votre mariage et cliquez sur « Calculer ». La calculatrice vous fournit :</p>
                <ul>
                  <li>La durée exacte du mariage en années, mois et jours</li>
                  <li>La date du prochain anniversaire de mariage avec le compte à rebours en jours</li>
                  <li>Le numéro de l'anniversaire cette année (1ères noces, 5èmes noces...)</li>
                  <li>La suggestion de cadeau traditionnel correspondant à cet anniversaire</li>
                  <li>Un message de félicitations personnalisé</li>
                </ul>
              </div>
            </div>
            <div className="info-section">
              <div className="info-section-header">Cadeaux traditionnels par année de mariage</div>
              <div className="info-section-body">
                <ul>
                  <li><strong>1 an — Noces de coton :</strong> nouvelle page qui s'écrit, cadeaux en tissu ou papier</li>
                  <li><strong>5 ans — Noces de bois :</strong> solidité du couple, cadeaux en bois (mobilier, gravure)</li>
                  <li><strong>10 ans — Noces d'étain :</strong> flexibilité et résilience, bijoux ou objets en métal</li>
                  <li><strong>15 ans — Noces de cristal :</strong> clarté et transparence, verres en cristal, tableau</li>
                  <li><strong>20 ans — Noces de porcelaine :</strong> finesse et élégance, service de table</li>
                  <li><strong>25 ans — Noces d'argent :</strong> demi-siècle honoré, bijoux en argent, voyage</li>
                  <li><strong>30 ans — Noces de perle :</strong> patience et beauté, collier de perles, escapade</li>
                  <li><strong>40 ans — Noces de rubis :</strong> passion toujours vive, bijoux en rubis</li>
                  <li><strong>50 ans — Noces d'or :</strong> demi-siècle de bonheur, bijoux en or, grand voyage</li>
                  <li><strong>60 ans — Noces de diamant :</strong> le cadeau le plus précieux, bague ou montre en diamant</li>
                </ul>
              </div>
            </div>
            <div className="info-section">
              <div className="info-section-header">Questions fréquentes</div>
              <div className="info-section-body">
                <h3 style={{ fontSize: "16px" }}><strong>Comment calculer les années de mariage ?</strong></h3>
                <p>Entrez votre date de mariage et la calculatrice déterminera automatiquement la durée exacte de votre union en années, mois et jours, ainsi que la date de votre prochain anniversaire.</p>
                <hr />
                <h3 style={{ fontSize: "16px" }}><strong>Quand célèbre-t-on les noces d'or ?</strong></h3>
                <p>Les noces d'or se célèbrent après <strong>50 ans de mariage</strong>. C'est l'un des anniversaires les plus importants, symbolisé par l'or qui représente la valeur et la durée d'une vie partagée.</p>
                <hr />
                <h3 style={{ fontSize: "16px" }}><strong>Quelle est la différence entre noces d'argent et noces d'or ?</strong></h3>
                <p>Les <strong>noces d'argent</strong> marquent 25 ans de mariage et symbolisent la solidité du couple. Les <strong>noces d'or</strong> célèbrent 50 ans, représentant la valeur inégalable d'une union durable. Ces deux étapes font l'objet de grandes célébrations en famille.</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Calculator;
